import React from 'react';
import { Button } from 'react-bootstrap';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import './Pagination.css';

/**
 * Компонент пагинации
 * @param {number} currentPage - текущая страница
 * @param {number} totalPages - общее количество страниц
 * @param {function} onPageChange - функция для смены страницы
 * @returns {JSX.Element} Компонент пагинации
 */
const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    
    // Функция для генерации номеров страниц для пагинации
    const getPaginationNumbers = () => {
        if (totalPages <= 7) {
            // Если страниц мало, показываем все
            return Array.from({ length: totalPages }, (_, i) => i + 1);
        } else {
            const pages = [];
            
            // Всегда показываем первую страницу
            pages.push(1);
            
            // Если текущая страница близка к началу
            if (currentPage <= 3) {
                pages.push(2, 3, 4, '...', totalPages - 1, totalPages);
            } 
            // Если текущая страница близка к концу
            else if (currentPage >= totalPages - 2) {
                pages.push('...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            } 
            // Если текущая страница где-то в середине
            else {
                pages.push('...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
            }
            
            return pages;
        }
    };

    // Если страниц меньше двух, не показываем пагинацию
    if (totalPages <= 1) return null;

    return (
        <div className="d-flex justify-content-between align-items-center mb-5">
            {/* Кнопка для телефона и планшета */}
            <Button 
                className="pagination-btn d-block d-lg-none"
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
            >
                <FaArrowLeft />
            </Button>
            {/* Кнопка для ПК */}
            <Button 
                className="pagination-btn d-none d-lg-inline"
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
            >
                <div className="d-flex align-items-center">
                    <FaArrowLeft className="me-2" /> 
                    <span>Предыдущая</span>
                </div>
            </Button>

            <div className="pagination-numbers">
                {getPaginationNumbers().map((page, index) => (
                    <Button 
                        key={index}
                        className={page === currentPage ? "pagination-btn-number-active mx-1" : 
                                page === '...' ? "pagination-btn-number mx-1 disabled" : "pagination-btn-number mx-1"}
                        onClick={() => page !== '...' && onPageChange(page)}
                        disabled={page === '...'}
                    >
                        {page}
                    </Button>
                ))}
            </div>

            {/* Кнопка для телефона и планшета */}
            <Button 
                className="pagination-btn d-block d-lg-none"
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
            >
                <FaArrowRight />
            </Button>
            {/* Кнопка для ПК */}
            <Button 
                className="pagination-btn d-none d-lg-inline"
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
            >
                <div className="d-flex align-items-center">
                    <span>Следующая</span>
                    <FaArrowRight className="ms-2" />
                </div>
            </Button>
        </div>
    );
};

export default Pagination;